module.exports = __webpack_public_path__ + "img/token-created.a2269785.svg";